import { AxiosResponse } from 'axios';
import api from '../../api';

class RewardsService {
  getAllRewards() {
    return api.get('/reward/');
  }
  getReward(id: string): Promise<AxiosResponse<any | null>> {
    return api.get<any>(`/reward/${id}`, {
      headers: { dashboard: true }
    });
  }

  createReward(reward: any, files?: any): Promise<AxiosResponse<any | null>> {
    const formData = new FormData();
    formData.append('label', reward.label);
    formData.append('description', reward.description);
    formData.append('type', reward.type);
    formData.append('price', reward.price.toString());
    formData.append('quantity', reward.quantity.toString());
    formData.append('requiredPoints', reward.requiredPoints.toString());
    formData.append('picture', files);

    return api.post<any>('/reward/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  editReward(reward: any, files?: any): Promise<AxiosResponse<any | null>> {
    const formData = new FormData();
    formData.append('_id', reward._id || '');
    formData.append('label', reward.label);
    formData.append('description', reward.description);
    formData.append('type', reward.type);
    formData.append('price', reward.price.toString());
    formData.append('quantity', reward.quantity.toString());
    formData.append('requiredPoints', reward.requiredPoints.toString());
    formData.append('picture', files);

    return api.put<any>('/reward/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  deleteReward(rewardID: string) {
    return api.delete<null>(`/reward/${rewardID}`);
  }
}

export default new RewardsService();
